
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guidelines",
      function () {
        return require("private-next-pages/guidelines/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guidelines"])
      });
    }
  